// Shared activity shell (T-0.2).
export const SESSION_VERSION = 1;
export const SESSION_STATUS = { RUNNING: 'running', COMPLETED: 'completed' };
export const LOAD_STATUS = { LOADING: 'loading', READY: 'ready', ERROR: 'error' };
export const DEFAULT_BATCH_SIZE = 20;
export const FEEDBACK_DELAY_MS = 700;
export const INCORRECT_MODE = Object.freeze({ ADVANCE: 'advance', RETRY: 'retry' });
export const REWARD_MODE = Object.freeze({ NONE: 'none', PLAYFUL: 'playful' });
export const TIMER_TICK_MS = 1000;
export const SEED_RADIX = 36;
export const FNV_OFFSET = 2166136261;
export const FNV_PRIME = 16777619;
export const UINT32_RANGE = 2 ** 32;
export const PERCENT = 100;
export const COMPLETION = { COUNT: 'count', TIMER: 'timer', OFFICIAL: 'official' };

export const ACTIVITY_TRANSITION_MS = 400;
export const REVEAL_SETTLE_MS = 100;
